import {
  typeBool,
  _setNull,
  remove,
  _getValue,
  createNumberList,
} from '../common/basefn'
const __enableDeposit = [
  'detail!depositDealPayType', // 定金设置方式
  'detail!depositPayType', // 支付尾款方式
  'time!iControlTime', // 线上付尾款规则
  'detail!minimumDeposits', // 最小订单金额
  'detail!deposits', // 固定金额
  'detail!depositPercentage', // 成交金额百分比
  'detail!enablemodifyDeposit', // 订单改价时可修改定金
  'time!ControlTimeType', // 线上付尾款控制方式
  'time!dateRange', // 尾款日期范围
  'time!RelativeDate', // 支付定金后
  'time!durationDate', // 支付定金后
];
const measurementUnitArr = {
  "detail!purchaseUnit_Name": "detail!purchaseRate", // 采购单位
  "detail!stockUnit_Name": "detail!stockRate", // 库存单位
  "detail!batchUnit_Name": "detail!batchRate", // 批发单位
  "detail!onlineUnit_Name": "detail!onlineRate", // 线上零售单位
  "detail!offlineUnit_Name": "detail!offlineRate", // 线下零售单位
  "detail!requireUnit_Name": "detail!requireRate", // 要货单位
  "detail!batchPriceUnit_Name": "detail!batchPriceRate", // 批发报价单位
};
const assistUnitRates = {
  "detail!purchaseRate": "采购单位换算率",
  "detail!stockRate": "库存单位换算率",
  "detail!batchRate": "批发单位换算率",
  "detail!onlineRate": "线上零售单位换算率",
  "detail!offlineRate": "线下零售单位换算率",
  "detail!requireRate": "要货单位换算率",
  "detail!batchPriceRate": "批发报价单位换算率",
}
const basicInfo = [
  "code", // 编码
  "name", // 编码
  "erpCode", // 商家编码
  "realProductAttribute", // 商品性质
  "realProductAttributeType", // 实物商品属性
  "virtualProductAttribute", // 虚拟商品属性
  "businessAttribute", // 业务属性
  "taxClass_Code", // 税收分类码
  "couponId_Name", // 卡券
  "giftCardId_Name", // 礼品卡
  "productLine_Name", // 产品线
  "saleStyle", // 销售方式
  "shortName", // 商品简称
  "modelDescription", // 规格型号
  "mnemonicCode", // 助记码
  "description!titleMemo", // 卖点
  "keywords", // 关键字
  "productClass_Name", // 商品分类
  "manageClass_Name", // 管理分类
  "productTemplate_Name", // 商品模板
  "brand_Name", // 商品品牌
  // "isRecommend", //推荐商品
  "shareDescription", // 分享说明
  "customerServiceDay", // 售后服务期限
  // "iOrder", //排序号
  "productTags", // 商品标签
  "productAssistClasses", // 辅助分类
  "unit_Name", // 主计量单位
  "receiptName", // 开票名称
  // "inTaxrate", //进项税率
  // "outTaxrate" //销项税率
  // BASE-8239
  'length', // 长
  'width', // 宽
  'height', // 高
];
const staticSKU = {
  "erpCode": null, // 商家SKU
  "productSKUDetail!batchPrice": null, // 批发价
  "productSKUDetail!markPrice": null, // 建议零售价
  "productSKUDetail!salePrice": null, // 线上零售价
  "productSKUDetail!fMarketPrice": null, // 市场价
  "productSKUDetail!fPrimeCosts": null, // 进货价格
  "productSKUDetail!status": 0, // 商城上架
  "productSKUDetail!ustatus": 0, // U订货上架
  "productSKUDetail!saled": 0, // 已售标记
  "productSKUDetail!fSettleAccountsRate": null, // 结算费率
  "productSKUDetail!inventoryCount": null, // 库存
  "productSKUDetail!weight": null, // 重量
  "productSKUDetail!barCode": null, // 条形码
  "productSKUDetail!batchUnit_Name": null, // 批发单位
  "productSKUDetail!batchRate": null, // 批发单位换算率
};
let setMinArr = [
  "detail!fSettleAccountsRate", // 结算费率%
  "detail!fPrimeCosts", // 进货价
  "detail!batchPrice", // 批发价
  "detail!fMarkPrice", // 建议零售价
  "detail!fSalePrice", // 线上零售价
  "detail!weight", // 重量
  "detail!volume", // 体积
  "detail!highestStock", // 最高库存
  "detail!lowestStock", // "最低库存"
  "detail!ropStock", // "再订货点"
  "detail!iMinOrderQuantity", // 起订量
  "detail!fLowestMarkPrice", // 最低零售价
  "detail!fMarketPrice", // 市场价
  "detail!deposits", // 固定金额
  "detail!minimumDeposits", // 最小订单金额
  "detail!deliveryDays", // 交货周期（天）
  "detail!lInventoryCount", // 线上库存量
  "detail!iBaseSaleCount", // 初始销量
  "detail!fNoTaxCostPrice", // 无税成本价
  "detail!depositPercentage", // 成交金额百分比
  "detail!iOrder", // 排序号
  'detail!serviceDuration', // 服务时长
];
const priceArr = [ // 价格字段
  "detail!batchPrice", // 批发价
  "detail!fMarkPrice", // 建议零售价
  "detail!fLowestMarkPrice", // 最低零售价
  "detail!fSalePrice", // 线上零售价
  "detail!fMarketPrice", // 市场价
  "detail!fPrimeCosts", // 进货价
  "detail!fSettleAccountsRate", // 结算费率%
]
// 判断SKU页签显示的条件之一
const diffSKUCondition = (viewmodel) => {
  let realProductAttribute = _getValue(viewmodel, 'realProductAttribute'); // 商品性质
  let realProductAttributeType = _getValue(viewmodel, 'realProductAttributeType'); // 实物商品属性
  let virtualProductAttribute = _getValue(viewmodel, 'virtualProductAttribute'); // 虚拟商品属性
  return (realProductAttribute == 1 && realProductAttributeType == 1) || (realProductAttribute == 2 && (virtualProductAttribute == 4 || virtualProductAttribute == 7 || virtualProductAttribute == 11 || virtualProductAttribute == 9))
}
// 批发报价单位
// const diffbatchPriceUnit = (viewmodel) => {
//   let unit = _getValue(viewmodel, 'unit');
//   let batchUnit = _getValue(viewmodel, 'detail!batchUnit');
//   let batchPriceUnit = _getValue(viewmodel, 'detail!batchPriceUnit');
//   if (batchPriceUnit !== unit || batchPriceUnit != batchUnit) {
//     clearbatchPriceUnit(viewmodel);
//   }
// }
const rolesUnits = (viewmodel) => {
  var _isTrue = [];
  Object.keys(measurementUnitArr).forEach((v) => {
    if (_getValue(viewmodel, v) && !_getValue(viewmodel, measurementUnitArr[v])) {
      _isTrue.push(assistUnitRates[measurementUnitArr[v]])
    }
  })
  return _isTrue // 返回false 表示有值没校验通过
}
// 判断模板中计量单位返回的值里面是否有计量单位
const hasUnits = (Units) => {
  if (!Units || !cb.utils.isArray(Units)) return false;
  let _localkey = Object.keys(measurementUnitArr).map(v => v.substr(7));
  _localkey.push('unit_Name');
  let _UnitsKeys = Object.keys(Units[0]);
  let _isTrue = false;
  _localkey.forEach((v) => {
    _isTrue = _isTrue || _UnitsKeys.includes(v);
  })
  return _isTrue
}
// 是否是创建者
const diffcreator = (viewmodel) => {
  let isCreator = viewmodel.getParams().carryParams ? viewmodel.getParams().carryParams.isCreator : true;
  return typeBool(isCreator, true)
  // return false
}
// 商品性质
const diffrealProductAttribute = (viewmodel, virtualProductAttributeData, saleChannel) => {
  virtualProductAttributeData = virtualProductAttributeData || 7;
  let val = _getValue(viewmodel, 'realProductAttribute') == '2' ? true : false;
  let virtualProductAttributeModel = viewmodel.get('virtualProductAttribute'); // 虚拟商品属性
  let realProductAttributeTypeModel = viewmodel.get('realProductAttributeType'); // 实物商品属性
  virtualProductAttributeModel.setVisible(val);
  realProductAttributeTypeModel.setVisible(!val);
  let saleChannelModel = viewmodel.get('detail!saleChannel');
  if (val) { // 当是虚拟商品时 销售渠道 值清空
    virtualProductAttributeModel.setValue(virtualProductAttributeData);
    saleChannel = saleChannelModel.getValue();
    let _saleChannel = [].concat(saleChannel);
    let index = _saleChannel.indexOf('1');
    if (index > -1) {
      _saleChannel.splice(index, 1);
    }
    realProductAttributeTypeModel.setValue(null)
    saleChannelModel.setValue([].concat(_saleChannel));
  } else {
    virtualProductAttributeData = virtualProductAttributeModel.getValue();
    virtualProductAttributeModel.setValue(null);
    saleChannelModel.setValue(saleChannel);
  }
  diffvirtualProductAttribute(viewmodel);
  diffrealProductAttributeType(viewmodel);
}
// 虚拟商品属性 相关
const diffvirtualProductAttribute = (viewmodel) => {
  let _val = _getValue(viewmodel, 'virtualProductAttribute');
  diffiStatus(viewmodel);
  diffiUOrderStatus(viewmodel);
  let _isTrue = (_val == 2);
  let giftCardId_NameModel = viewmodel.get('giftCardId_Name');
  giftCardId_NameModel.setVisible(_isTrue); //  {\"7\":\"服务\",\"3\":\"卡券\",\"2\":\"礼品卡\",\"1\":\"储值卡\",\"4\":\"其它\"}
  giftCardId_NameModel.setState('bIsNull', !_isTrue);
  diffcouponId_Name(viewmodel);
  viewmodel.get('detail!fMarketPrice').setDisabled(_isTrue);
  diffserviceDuration(viewmodel);
}
// 实物商品属性
const diffrealProductAttributeType = (viewmodel) => {
  let realProductAttributeType = _getValue(viewmodel, 'realProductAttributeType');
  let val = (realProductAttributeType == 2 || realProductAttributeType == 3); // 实体卡券 实体储值卡
  diffiStatus(viewmodel);
  diffiUOrderStatus(viewmodel);
  if(viewmodel.getCache("isLoaded")) {
      if (val) { // 销售渠道
        viewmodel.get('detail!saleChannel').setValue([3]);
      } else {
        viewmodel.get('detail!saleChannel').setValue([1, 2, 3, 4]);
      }
  }
  viewmodel.get('detail!saleChannel').setDisabled(val)
  diffcouponId_Name(viewmodel)
}
// 业务属性
const diffbusinessAttribute = (viewmodel) => {
  let realProductAttribute = _getValue(viewmodel, 'realProductAttribute'); // 商品性质
  let realProductAttributeType = _getValue(viewmodel, 'realProductAttributeType');
  viewmodel.get('businessAttribute').setVisible(realProductAttribute == '1' && realProductAttributeType == '1')
}
// 卡券显示隐藏
const diffcouponId_Name = (viewmodel) => {
  let realProductAttributeType = _getValue(viewmodel, 'realProductAttributeType'); // 实物商品属性
  let virtualProductAttribute = _getValue(viewmodel, 'virtualProductAttribute'); // 虚拟商品属性
  let _isTrue = virtualProductAttribute == 3 || realProductAttributeType == 2;
  viewmodel.get('couponId_Name').setVisible(_isTrue); // 卡券 -> 卡券打开
  viewmodel.get('couponId_Name').setState('bIsNull', !_isTrue); // 卡券 -> 卡券打开
}
// 销售渠道
const diffsaleChannel = (viewmodel, args) => {
  let diffvalue = _getValue(viewmodel, 'detail!saleChannel');
  if (!diffvalue.includes('2') && diffvalue.includes('4')) {
    let { oldValue } = args;
    let isInclude2 = oldValue.filter(v => v.value === '2');
    if (!isInclude2.length) {
      cb.utils.alert("商品不在线上销售时，不能勾选微分销", 'warning');
    }
    diffvalue = remove(diffvalue, '4');
    viewmodel.get('detail!saleChannel').setValue([].concat(diffvalue));
  }
}
// 业务属性
const diffbusinesSattriBute = (viewmodel) => {
  let businessAttribute = _getValue(viewmodel, "detail!businessAttribute"); // 业务属性值
  let _isTrue = businessAttribute.includes('7');
  viewmodel.get('productClass_Name').setState('bIsNull', !_isTrue);
}
// 服务时长
const diffserviceDuration = (viewmodel) => {
  let realProductAttribute = _getValue(viewmodel, 'realProductAttribute'); // 商品性质
  let virtualProductAttribute = _getValue(viewmodel, 'virtualProductAttribute'); // 虚拟商品属性
  let _isTrue = realProductAttribute == 2 && virtualProductAttribute == 7
  viewmodel.get('detail!serviceDuration').setVisible(_isTrue); // 服务时长
  viewmodel.get('detail!serviceDurationUnit').setVisible(_isTrue); // 服务时长 单位
  viewmodel.get('detail!canOrder').setVisible(_isTrue); // 服务时长 单位
  if (!_isTrue) {
    viewmodel.get('detail!canOrder').setValue(false);
    viewmodel.get('detail!onlyOrder').setValue(false);
    viewmodel.get('detail!orderAdvanceTime').setValue(0);
    diffcanOrder(viewmodel); //
  }
}
// 可预约
const diffcanOrder = (viewmodel) => {
  let canOrder = typeBool(_getValue(viewmodel, 'detail!canOrder')); // 可预约
  viewmodel.get('detail!onlyOrder').setVisible(canOrder); // 仅预约
  viewmodel.get('detail!orderAdvanceTime').setVisible(canOrder) // 预约提前期
}
// 销售方式 2:积分换购 -> 业务信息页签 积分数量 true SKU 列表 积分数量显示
const diffsaleStyle = (viewmodel) => {
  const saleStyle = _getValue(viewmodel, 'saleStyle');
  let val = (saleStyle == '2');
  viewmodel.get('detail!salePoints').setVisible(val);
  let productskusModel = viewmodel.get('productskus');
  productskusModel.setColumnState("productSKUDetail!salePoints", 'visible', val)
}
// 启用状态
const diffstopstatus = (viewmodel) => {
  diffiStatus(viewmodel);
  diffiUOrderStatus(viewmodel);
  // 商品停用 -> SKU状态也停用
  let productskusModel = viewmodel.get('productskus');
  let productskusData = productskusModel.getAllData();
  let stopstatusData = typeBool(_getValue(viewmodel, 'detail!stopstatus'), false); // 停用状态
  if (productskusData.length) {
    createNumberList(productskusData.length).forEach((value, index) => {
      if (stopstatusData) {
        productskusModel.setCellValue(index, "productSKUDetail!stopstatus", true)
      }
      productskusModel.setCellState(index, "productSKUDetail!stopstatus", 'readOnly', stopstatusData)
    })
  }
}
// 商品启用/停用状态判断
const getdiffiStatusVal = (viewmodel) => {
  let iStatusData = typeBool(_getValue(viewmodel, 'detail!stopstatus')); // true 是停用
  let realProductAttribute = _getValue(viewmodel, 'realProductAttribute'); // 商品性质
  let realProductAttributeType = _getValue(viewmodel, 'realProductAttributeType'); // 实物商品属性
  let virtualProductAttribute = _getValue(viewmodel, 'virtualProductAttribute'); // 虚拟商品属性
  let _val = iStatusData || ((realProductAttribute == 1 && realProductAttributeType != 1) || (realProductAttribute == 2 && virtualProductAttribute == 1));
  return _val
}
// 商城上架 --> 暂时不用
const diffiStatus = (viewmodel) => {
  let iStatusData = typeBool(_getValue(viewmodel, 'detail!iStatus'));
  let productskusModel = viewmodel.get('productskus');
  let productskusData = productskusModel.getAllData();
  if (productskusData.length) {
    createNumberList(productskusData.length).forEach((value, index) => {
      if (!iStatusData) {
        productskusModel.setCellValue(index, 'productSKUDetail!status', false)
      }
      productskusModel.setCellState(index, 'productSKUDetail!status', 'readOnly', !iStatusData)
    })
  }
  let diffiStatusVal = getdiffiStatusVal(viewmodel);
  let iStatusModel = viewmodel.get('detail!iStatus');
  iStatusModel.setDisabled(diffiStatusVal);
  if (diffiStatusVal) {
    iStatusModel.setValue(false)
  }
}
// U订货上架 --> 暂时不用
const diffiUOrderStatus = (viewmodel) => {
  let iUOrderStatusData = typeBool(_getValue(viewmodel, 'detail!iUOrderStatus'));
  let productskusModel = viewmodel.get('productskus');
  let productskusData = productskusModel.getAllData();
  if (productskusData.length) {
    createNumberList(productskusData.length).forEach((value, index) => {
      if (!iUOrderStatusData) {
        productskusModel.setCellValue(index, 'productSKUDetail!ustatus', false)
      }
      productskusModel.setCellState(index, 'productSKUDetail!ustatus', 'readOnly', !iUOrderStatusData)
    })
  }
  let diffiStatusVal = getdiffiStatusVal(viewmodel);
  let iUOrderStatusModel = viewmodel.get('detail!iUOrderStatus');
  iUOrderStatusModel.setDisabled(diffiStatusVal);
  if (diffiStatusVal) {
    iUOrderStatusModel.setValue(false)
  }
}
// 非创建者的时候把这些值 只读
const diffbasicInfo = (viewmodel) => {
  if (diffcreator(viewmodel)) return false
  basicInfo.forEach((v) => {
    viewmodel.get(v).setDisabled(true);
  })
  viewmodel.get('productBarCodes').setState('readOnly', true);
  //强制渲染该页签 加载viewmodel 使隐藏按钮代码生效!
  viewmodel.execute('updateViewMeta', {
    code: '多条码页签',
    forceRender: true,
  });
  //lichi 多条码表格 内容不可编辑 增删行按钮也不显示
  viewmodel.get('btnAddRow_barcodeUnit').setVisible(false);
  for (let i = 0; i < viewmodel.get('productBarCodes').getRowsCount(); i++) {
    viewmodel.get('productBarCodes').setCellState(i, 'barCode', 'disabled', true);
    viewmodel.get('productBarCodes').setCellState(i, 'unitName', 'disabled', true);
    viewmodel.get('productBarCodes').setActionState(i, "btnDeleteRow_barcodeUnit", "visible", false);
  }
  viewmodel.get('taxClass_Name').setState('readOnly', true);
  // viewmodel.get("detail!saleChannel").setState('readOnly', true);
  viewmodel.get("productspecitems").setState('readOnly', true);
  viewmodel.get("productAttachments").setState('mode', 'browse');
  viewmodel.get("productAlbums").setState('mode', 'browse');
  viewmodel.get("description!description").setState('readOnly', true);
  viewmodel.get("description!mobileDescription").setState('readOnly', true);
  viewmodel.get('productOrgs').setState('mode', 'browse');
  viewmodel.get('productShops').setState('mode', 'browse');
  let productskusModel = viewmodel.get('productskus');
  createNumberList(productskusModel.getAllData().length).forEach((value, index) => {
    productskusModel.setCellState(index, 'code', 'readOnly', true)
    productskusModel.setCellState(index, 'name', 'readOnly', true)
    productskusModel.setCellState(index, 'shortName', 'readOnly', true)
    productskusModel.setCellState(index, 'erpCode', 'readOnly', true)
    productskusModel.setCellState(index, 'modelDescription', 'readOnly', true)
    createNumberList(60).forEach((val, ind) => {
      productskusModel.setCellState(index, 'skudefine!define' + (ind + 1), 'readOnly', true)
    })
  })
}
// 更改管理分类、商品分类 引起的模板更改
const diffproductTemplate = (viewmodel, args) => {
  let productTemplate_NameModel = viewmodel.get('productTemplate_Name');
  let productTemplate_Name = productTemplate_NameModel.getValue();
  let template = args.value && args.value.template; // 模板
  let templateName = args.value && args.value.templateName;
  if (!productTemplate_Name && templateName) {
    productTemplate_NameModel.setValue(templateName);
    viewmodel.get('productTemplate').setValue(template);
    productTemplate_NameModel.execute('afterValueChange', {
      value: { id: template, name: templateName },
    });
  }
}
// 清空模板带来的数据
const clearTemplate = (viewmodel) => {
  viewmodel.execute('updateViewMeta', { code: '商品属性页签', visible: false });
  viewmodel.execute('updateViewMeta', { code: 'SKU页签', visible: false });
  viewmodel.execute('updateViewMeta', {
    code: 'DefaultSKUOrderPropsGroup',
    visible: false,
  });
  // clearmeasurementUnitArr(viewmodel); // 清空计量单位
  createNumberList(30).forEach((val, i) => {
    let _defineId = 'define!define' + (i + 1);
    viewmodel.get(_defineId).setState('bIsNull', true);
  })
  let productskusModel = viewmodel.get('productskus');
  let productskusData = productskusModel.getData() || [];
  if (productskusData.length) {
    productskusModel.deleteRows(createNumberList(productskusData.length));
  }
  let productspecitemsModel = viewmodel.get('productspecitems');
  productspecitemsModel.setState('dataSource', {});
  let productspecitemsData = productspecitemsModel.getData() || [];
  if (productspecitemsData.length) {
    productspecitemsModel.deleteItems(createNumberList(productspecitemsData.length));
  }
  let productparamsModel = viewmodel.get('productParams');
  let productparamsData = productparamsModel.getData() || [];
  if (productparamsData.length) {
    productparamsModel.deleteRows(createNumberList(productparamsData.length));
  }
  viewmodel.get("detail!iEnableCyclePurchase").setValue(false);
  viewmodel.get("detail!isWeight").setValue(false);
  // 运费模板ID、名字|订货运费模板ID、名字|线上库存量
  [
    "detail!dlyFeeRuleId",
    "detail!dlyFeeRuleId_Name",
    "detail!uorderDlyFeeRuleId",
    "detail!uorderDlyFeeRuleId_Name",
    'detail!lInventoryCount',
  ].forEach((v) => {
    _setNull(viewmodel, v)
  })
  // 线上库存量 恢复编辑态
  viewmodel.get('detail!lInventoryCount').setDisabled(false);
  let isCheckFreeModel = viewmodel.get('detail!isCheckFree');
  isCheckFreeModel.setValue('0');
  isCheckFreeModel.setVisible(false);
  viewmodel.get('productCheckFrees').setVisible(false);
}
const updatemeasurementUnitArr = (viewmodel, units = {}) => {
  Object.keys(measurementUnitArr).forEach((val) => {
    viewmodel.get(val).setValue(units[val.match(/detail\!(\S*)/)[1]] || units['unit_Name']);
    viewmodel.get(measurementUnitArr[val]).setValue(units[measurementUnitArr[val].match(/detail\!(\S*)/)[1]] || units['unit']);
    viewmodel.get(val.match(/(\S*)_Name/)[1]).setValue(units[val.match(/detail\!(\S*)_Name/)[1]] || units['unit']);
  })
  viewmodel.get("unit").setValue(units['unit'] || null);
  viewmodel.get("unit_Name").setValue(units['unit_Name'] || null);
  // 补丁
  viewmodel.get('detail!offlineUnit').setValue(units['unit'] || null);
  viewmodel.get('detail!offlineUnit_Name').setValue(units['unit_Name'] || null);
  diffmeasurementUnitArr(viewmodel);
}
const clearmeasurementUnitArr = (viewmodel) => {
  Object.keys(measurementUnitArr).forEach((v) => {
    _setNull(viewmodel, v)
    _setNull(viewmodel, v.match(/(\S*)_Name/)[1])
  })
  _setNull(viewmodel, 'unit')
  _setNull(viewmodel, 'unit_Name')
  diffmeasurementUnitArr(viewmodel);
}
// 清空批发报价单位
// const clearbatchPriceUnit = (viewmodel) => {
//   let arr = ["detail!batchPriceUnit", "detail!batchPriceUnit_Name", "detail!batchPriceRate"]
//   arr.forEach(v => {
//     _setNull(viewmodel, v)
//   })
//   viewmodel.get("detail!batchPriceRate").setDisabled(true);
// }
// 辅计量单位
const diffmeasurementUnitArr = (viewmodel) => {
  Object.keys(measurementUnitArr).forEach((val) => {
    diffUnit(viewmodel, val);
  })
}
const getbaseInfoToSKU = (viewmodel) => {
  let baseInfoobj = {};
  baseInfoobj = {
    "productSKUDetail!shortName": _getValue(viewmodel, 'shortName'), // 商品简称
    "name": _getValue(viewmodel, 'name'), // 商品名称
    "modelDescription": _getValue(viewmodel, 'modelDescription'), //  规格型号
    "productSKUDetail!batchDeliveryDays": _getValue(viewmodel, 'detail!deliveryDays'), // 交货周期
    "productSKUDetail!iMinOrderQuantity": _getValue(viewmodel, 'detail!iMinOrderQuantity'), // 起订量 'detail!iMinOrderQuantity'
    "productSKUDetail!fNoTaxCostPrice": _getValue(viewmodel, 'detail!fNoTaxCostPrice'),
  }
  return baseInfoobj
}
// 获取商品价格转换成SKU列表里面的价格
const getPriceToSKU = (viewmodel) => {
  let priceobj = {};
  priceArr.forEach((v) => {
    let _key;
    switch (v) {
      case 'detail!fMarkPrice':
      case 'detail!fSalePrice':
        let Str = v.substr(8);
        let str = Str.charAt(0).toLowerCase() + Str.slice(1);
        _key = 'productSKUDetail!' + str;
        break;
      default:
        _key = v.replace('detail', 'productSKUDetail');
    }
    priceobj[_key] = _getValue(viewmodel, v)
  })
  return priceobj
}
// 比较计量单位 与 主计量单位  对应的单位换算率
const diffUnit = (viewmodel, key) => {
  let _mainval = _getValue(viewmodel, 'unit_Name');
  let _keyval = _getValue(viewmodel, key);
  switch (key) {
    // case "detail!purchaseUnit_Name": // 采购单位
    //   if (_keyval) {
    //     viewmodel.get('detail!fPrimeCosts').setState('after', '元/' + _keyval);
    //   } else {
    //     viewmodel.get('detail!fPrimeCosts').setState('after', null);
    //   }
    //   break;
    case "detail!batchPriceUnit_Name": // 批发报价单位 -> 批发价
      if (_keyval) {
        viewmodel.get('detail!batchPrice').setState('after', '元/' + _keyval);
      } else {
        viewmodel.get('detail!batchPrice').setState('after', null);
      }
      break;
    case "detail!offlineUnit_Name":
      if (_keyval) {
        viewmodel.get('detail!fMarkPrice').setState('after', '元/' + _keyval);
        viewmodel.get('detail!fLowestMarkPrice').setState('after', '元/' + _keyval);
        viewmodel.get('detail!fPrimeCosts').setState('after', '元/' + _keyval);
      } else {
        viewmodel.get('detail!fMarkPrice').setState('after', null);
        viewmodel.get('detail!fLowestMarkPrice').setState('after', null);
        viewmodel.get('detail!fPrimeCosts').setState('after', null);
      }
      break;
    case "detail!onlineUnit_Name":
      if (_keyval) {
        viewmodel.get('detail!fMarketPrice').setState('after', '元/' + _keyval);
        viewmodel.get('detail!fSalePrice').setState('after', '元/' + _keyval);
      } else {
        viewmodel.get('detail!fMarketPrice').setState('after', null);
        viewmodel.get('detail!fSalePrice').setState('after', null);
      }
      break;
    default:
  }
  let measurementUnitArrKeyModel = viewmodel.get(measurementUnitArr[key]);
  if (!_keyval) {
    _setNull(viewmodel, measurementUnitArr[key]);
    measurementUnitArrKeyModel.setDisabled(true);
    return false
  }
  if (_keyval == _mainval) {
    viewmodel.get(measurementUnitArr[key]).setValue(1);
    measurementUnitArrKeyModel.setDisabled(true);
  } else {
    measurementUnitArrKeyModel.setDisabled(false);
  }
}
// 价格提示信息 显示隐藏
const diffisDisplayPrice = (viewmodel) => {
  let isDisplayPriceData = _getValue(viewmodel, 'detail!isDisplayPrice');
  let val = typeBool(isDisplayPriceData, true);
  viewmodel.get("detail!priceAreaMessage").setVisible(!val);
}
// 批次管理
const diffisBatchManage = (viewmodel) => {
  let isBatchManageData = _getValue(viewmodel, 'detail!isBatchManage');
  let val = typeBool(isBatchManageData, true);
  let isExpiryDateManageModel = viewmodel.get('detail!isExpiryDateManage'); // 有效期管理
  let checkByBatchModel = viewmodel.get('detail!checkByBatch'); // 按批次核算
  isExpiryDateManageModel.setDisabled(!val);
  checkByBatchModel.setDisabled(!val);
  if (val) {
    let processType = _getValue(viewmodel, 'detail!processType');
    if (processType == '1') { // 如果加工方式的值为1（现制） ，则改成 默认值
      viewmodel.get('detail!processType').setValue('0');
    }
  } else {
    isExpiryDateManageModel.setValue(false);
    checkByBatchModel.setValue(false);
  }
  diffisExpiryDateManage(viewmodel);
  // diffcheckByBatch(viewmodel);
}
// 有效期管理
const diffisExpiryDateManage = (viewmodel) => {
  let isExpiryDateManageData = _getValue(viewmodel, 'detail!isExpiryDateManage');
  let val = typeBool(isExpiryDateManageData, true);
  viewmodel.get('detail!expireDateNo').setState('bIsNull', !val);
  viewmodel.get('detail!expireDateUnit').setState('bIsNull', !val); // false 为不必输
  viewmodel.get('detail!expireDateNo').setVisible(val); // 保质期
  viewmodel.get('detail!expireDateUnit').setVisible(val); // 保质期单位
}
// 序列号管理 // 序列号管理 true=>加工：不可选择并且值为否；  false=>加工：可以选择
const diffisSerialNoManage = (viewmodel) => {
  let isSerialNoManage = _getValue(viewmodel, 'detail!isSerialNoManage');
  let val = typeBool(isSerialNoManage, true);
  let isProcess = _getValue(viewmodel, 'detail!isProcess'); // 加工的值
  if (isProcess === undefined) return
  let isProcessModel = viewmodel.get('detail!isProcess'); // 加工
  isProcessModel.setDisabled(val);
  if (val) {
    isProcessModel.setValue(false);
  }
  diffisProcess(viewmodel);
}
// 加工
const diffisProcess = (viewmodel) => {
  let isProcess = _getValue(viewmodel, 'detail!isProcess');
  isProcess = typeBool(isProcess, true)
  viewmodel.get('detail!processType').setVisible(isProcess);
  let processTypeModel = viewmodel.get('detail!processType') // 加工方式
  if (isProcess) {
    if (processTypeModel.getValue() == null) {
      processTypeModel.setValue('0'); // 加工方式 设置为0
    }
  } else {
    processTypeModel.setValue(null);
  }
}
// 加工方式
const diffprocessType = (viewmodel) => {
  let processType = _getValue(viewmodel, 'detail!processType');
  if (processType === '1') {
    viewmodel.get('detail!isBatchManage').setValue(false) // 现制 批次管理为false
    diffisBatchManage(viewmodel);
  }
}
// ///// 预订业务
// 定金设置方式
const diffdepositDealPayType = (viewmodel) => {
  let depositDealPayTypeData = _getValue(viewmodel, 'detail!depositDealPayType');
  let val = typeBool(depositDealPayTypeData, true);
  viewmodel.get('detail!depositPercentage').setVisible(val);
  viewmodel.get('detail!deposits').setVisible(!val);
}
// 线上付尾款控制方式
const difftimes_ControlTimeType = (viewmodel) => {
  let enableDeposit = _getValue(viewmodel, 'detail!enableDeposit');
  let isenableDeposit = typeBool(enableDeposit, true); // true 是 启动预定业务
  let isDepositPayType = typeBool(_getValue(viewmodel, 'detail!depositPayType'), false); // true 是线下
  let isiControlTimedata = _getValue(viewmodel, 'time!iControlTime');
  let isiControlTime = typeBool(isiControlTimedata, true); // true  是 不控制时间
  let isControlTimeType = typeBool(_getValue(viewmodel, 'time!ControlTimeType'), false); // true 相对时间

  viewmodel.get('time!dStartDate').setVisible(isenableDeposit && !isDepositPayType && isiControlTime && !isControlTimeType);
  viewmodel.get('time!dEndDate').setVisible(isenableDeposit && !isDepositPayType && isiControlTime && !isControlTimeType);
  viewmodel.get('time!dateRange').setVisible(isenableDeposit && !isDepositPayType && isiControlTime && !isControlTimeType);
  viewmodel.get('time!RelativeDate').setVisible(isenableDeposit && !isDepositPayType && isiControlTime && isControlTimeType);
  viewmodel.get('time!durationDate').setVisible(isenableDeposit && !isDepositPayType && isiControlTime && isControlTimeType);
}
// 是否启动预定业务
const diffenableDeposit = (viewmodel) => {
  let enableDeposit = _getValue(viewmodel, 'detail!enableDeposit');
  let isenableDeposit = typeBool(enableDeposit, true); // true 是 启动预定业务
  __enableDeposit.forEach((v) => {
    viewmodel.get(v).setVisible(isenableDeposit);
  })
  if (isenableDeposit) {
    diffdepositDealPayType(viewmodel);
    diffdepositPayType(viewmodel);
  }
}
// 线上付尾款规则
const difftimes_iControlTime = (viewmodel) => {
  let enableDeposit = _getValue(viewmodel, 'detail!enableDeposit');
  let isenableDeposit = typeBool(enableDeposit, true); // true 是 启动预定业务
  let isDepositPayType = typeBool(_getValue(viewmodel, 'detail!depositPayType'), false); // true 是线下
  let isiControlTimedata = _getValue(viewmodel, 'time!iControlTime');
  let isiControlTime = typeBool(isiControlTimedata, true); // true  是 不控制时间
  viewmodel.get('time!ControlTimeType').setVisible(isenableDeposit && !isDepositPayType && isiControlTime);
  difftimes_ControlTimeType(viewmodel);
}
// 支付尾款方式
const diffdepositPayType = (viewmodel) => {
  let enableDeposit = _getValue(viewmodel, 'detail!enableDeposit');
  let isenableDeposit = typeBool(enableDeposit, true); // true 是 启动预定业务
  let isDepositPayType = typeBool(_getValue(viewmodel, 'detail!depositPayType'), false); // true 是线下
  viewmodel.get('time!iControlTime').setVisible(isenableDeposit && !isDepositPayType);
  difftimes_iControlTime(viewmodel);
}
// 按批次核算
// const diffcheckByBatch = (viewmodel) => {
//   let checkByBatch = _getValue(viewmodel, 'detail!checkByBatch');
//   let val = typeBool(checkByBatch); //checkboxgroup 设置 disabled 是 readOnly
//   let productCheckFreesModel = viewmodel.get('productCheckFrees')
//   productCheckFreesModel.setState('readOnly', !val)
//   if (!val) { productCheckFreesModel.setValue([]); }
// }
// sku列表批量上下架
const diffSKUShelve = (viewmodel, name, state) => {
  let productskusModel = viewmodel.get('productskus');
  let productskusArrIndex = productskusModel.getSelectedRowIndexes();
  let selectedRows = productskusModel.getSelectedRows();
  selectedRows.length && selectedRows.forEach((row, index) => {
    if (state === !!row[name]) {
      productskusModel.setCellValue(productskusArrIndex[index], name, !state);
    }
  })
}

// sku 列表，自由项，在模板调整顺序后，sku列表的表头与内容对不上的bug
// Fixed 隐藏显示自由项，并显示名字
const diffFreex = (viewmodel, productskusModel, showItems2, SpecSums) => {
  let _params = viewmodel.getParams();
  let _productskusList = productskusModel.getAllData();
  showItems2.length && showItems2.forEach((val, i) => {
    let _title;
    if (_productskusList.length && _params.mode !== 'add') {
      let _firstProductskus = _productskusList[0]; // 取得第一个sku的值 反选title
      _title = _firstProductskus['freeidx' + (i + 1) + '_Name'];
    }
    productskusModel.setColumnState('freex' + (i + 1), 'cShowCaption', _title || val.title);
    productskusModel.setColumnState('freex' + (i + 1), "bMergeCol", true);
  })
  if (showItems2.length < 5) {
    createNumberList(5).forEach((val, i) => {
      productskusModel.setColumnState('freex' + (i + 1), 'visible', !(i > showItems2.length - 1));
    })
  }
}
// 隐藏SKU扩展属性
const diffSKUPropertySums = (productskusModel, SKUPropertySums, viewmodel) => {
  const _defines = [];
  const _isRequireds = [];
  SKUPropertySums.length && SKUPropertySums.forEach((v) => {
    _defines.push(v.propertyType_defineId);
    _isRequireds.push(v.isRequired);
  })
  var filterItems = [];
  createNumberList(60).forEach((val, i) => {
    let _define = 'skudefine!define' + (i + 1);
    let cSelfDefineType = productskusModel.getColumnState(_define, 'cSelfDefineType');
    let _index = _defines.indexOf(cSelfDefineType);
    productskusModel.setColumnState(_define, 'visible', _index >= 0);
    // if (_index >= 0 && !diffcreator(viewmodel)) {
    //   productskusModel.getEditRowModel().get(_define).setDisabled(true);
    // }
    if (_index < 0) {
      filterItems.push(_define)
    }
    if (_index >= 0) {
      productskusModel.setColumnState(_define, 'bIsNull', !_isRequireds[_index]);
    } else {
      productskusModel.setColumnState(_define, 'bIsNull', true);
    }
  })
  viewmodel.get('productskus').setState('filterItems', filterItems)
}
// 隐藏商品扩展属性
const diffPropertySums = (viewmodel, PropertySums) => {
  const _defineIds = [];
  PropertySums.length && PropertySums.forEach((v) => {
    _defineIds.push(v.propertyType_defineId);
  })
  createNumberList(30).forEach((val, i) => {
    let _defineId = 'define!define' + (i + 1);
    let _defineIdModel = viewmodel.get(_defineId);
    let cSelfDefineType = _defineIdModel.getState('cSelfDefineType');
    let _index = _defineIds.indexOf(cSelfDefineType);
    _defineIdModel.setVisible(_index >= 0);
    if (_index >= 0 && !diffcreator(viewmodel)) {
      _defineIdModel.setState('readOnly', true);
    }
    if (_index >= 0) {
      _defineIdModel.setState('bIsNull', !PropertySums[_index].isRequired);
    } else {
      _defineIdModel.setState('bIsNull', true);
    }
  })
}
// 商品订单属性
const diffOrderPropertySums = (viewmodel, OrderPropertySums, args) => {
  viewmodel.get('productskus').setFocusedRowIndex(args.params.index);
  let skuOrderPropertiesModel = viewmodel.get('skuOrderProperties');
  let skuOrderPropertiesData = skuOrderPropertiesModel.getData();
  let _skuOrderPropertiesData = []; // 设置新的商品订单属性集合
  OrderPropertySums.length && OrderPropertySums.forEach((val, index) => {
    let _values = val.values;
    if (_values && _values.indexOf(';') >= 0) {
      _values = _values.replace(new RegExp('; ', 'g'), '|');
    }
    let __skuOrderPropertiesData = skuOrderPropertiesData.filter(v => v.skuPropertyTypeId == val.id); // 是否包含
    let _obj = {
      "skuPropertyTypeId_showItem": val.propertyType_showItem, // 属性名称
      "skuPropertyTypeId_alias": val.alias, // 属性别名
      "skuPropertyTypeId_type": val.propertyType_type, // 数据类型
      "skuPropertyTypeId_userdefMode": val.propertyType_userdefMode, // 录入方式
    };
    if (!__skuOrderPropertiesData.length) {
      _obj['skuPropertyTypeId'] = val.id;
      _obj['promptMessage'] = _values;
      _obj['isShow'] = val.isShow;
      _obj['isRequired'] = val.isRequired;
      _obj['iOrder'] = val.order;
      _obj['productApplyRangeId'] = val.productApplyRangeId;
      _obj['iLimitNum'] = val.propertyType_maxInputLen;
      skuOrderPropertiesModel.insertRow(index, _obj);
    } else {
      _obj['skuPropertyTypeId'] = __skuOrderPropertiesData[0].skuPropertyTypeId; // id
      _obj['promptMessage'] = __skuOrderPropertiesData[0].promptMessage; // 属性值
      _obj['isShow'] = __skuOrderPropertiesData[0].isShow; // 前端显示
      _obj['isRequired'] = __skuOrderPropertiesData[0].isRequired; // 前端必输
      _obj['iOrder'] = __skuOrderPropertiesData[0].iOrder; // 排序
      _obj['id'] = __skuOrderPropertiesData[0].id; // 排序
      _obj['productApplyRangeId'] = __skuOrderPropertiesData[0].productApplyRangeId; // 排序
      _obj['iLimitNum'] = __skuOrderPropertiesData[0].iLimitNum; // 字数限制
      skuOrderPropertiesModel.updateRow(index, _obj);
    }
    _skuOrderPropertiesData.push(_obj);
    skuOrderPropertiesModel.getEditRowModel().get('iLimitNum').setState('min', 0)
    skuOrderPropertiesModel.getEditRowModel().get('iLimitNum').setState('max', val.propertyType_maxInputLen)
  })
  skuOrderPropertiesData = skuOrderPropertiesModel.getData();
  let _delIndexs = [];
  skuOrderPropertiesData.map((v, index) => {
    if ((!OrderPropertySums[index] || v.skuPropertyTypeId !== OrderPropertySums[index].id) && v._status != "Delete") {
      _delIndexs.push(index);
    }
  })
  if (_delIndexs.length) {
    skuOrderPropertiesModel.deleteRows(_delIndexs);
  }
  skuOrderPropertiesModel.setDataSource(_skuOrderPropertiesData)
  skuOrderPropertiesModel.on('beforeBrowse', function (data) {
    let datacontextModel = data.context;
    datacontextModel.setState('cSelfDefineType', OrderPropertySums[data.rowIndex]['propertyType_defineId']);
    datacontextModel.setState('bSelfDefine', true);
  })
  skuOrderPropertiesModel.on('rowColChange', ({ value }) => {
    switch (value.columnKey) {
      case "promptMessage":
        let rowData = skuOrderPropertiesModel.getRow(value.rowIndex);
        let skuPropertyTypeId_userdefMode = rowData.skuPropertyTypeId_userdefMode;
        let skuPropertyTypeId_type = rowData.skuPropertyTypeId_type;
        if (skuPropertyTypeId_userdefMode == 1 || skuPropertyTypeId_userdefMode == 2) { // 当本行的 录入方式 是 选择项或是 输入+选择 的时候 是Refer
          value.column.cControlType = 'Refer';
        } else {
          value.column.cControlType = 'Input';
        }
        if (skuPropertyTypeId_type === 'Double') {
          value.column.cControlType = 'InputNumber';
          let decimalDigits = OrderPropertySums[value.rowIndex].propertyType_decimalDigits || 0;
          value.column.iNumPoint = decimalDigits;
        }
        break;
      case "iLimitNum":
        value.column.max = OrderPropertySums[value.rowIndex].iLimitNum;
        break;
      default:
    }
  });
  viewmodel.communication({
    type: 'modal',
    payload: { mode: 'inner', groupCode: '订单属性Div', viewModel: viewmodel },
  })
}
// 会员价
const diffskulvprice = (viewmodel, args) => {
  viewmodel.get('productskus').setFocusedRowIndex(args.params.index);
  let productLvPricesModel = viewmodel.get('productLvPrices');
  let productLvPricesData = productLvPricesModel.getData();
  productLvPricesData = productLvPricesData.filter(v => v._status != "Delete")
  let productSKULvPricesModel = viewmodel.get('productSKULvPrices');
  let productSKULvPricesData = productSKULvPricesModel.getData();
  productSKULvPricesData = productSKULvPricesData.filter(v => v._status != "Delete");
  let _productLvPricesLength = productLvPricesData.length;
  let _productSKULvPricesLength = productSKULvPricesData.length;

  if (!_productLvPricesLength && _productSKULvPricesLength) {
    productSKULvPricesModel.deleteRows(createNumberList(_productSKULvPricesLength));
  } else if (_productLvPricesLength && !_productSKULvPricesLength) {
    productLvPricesData.forEach((val, index) => {
      delete val.fLevelPrice
      delete val.id
      delete val.pubts
      productSKULvPricesModel.insertRow(index, val);
    })
  } else if (_productLvPricesLength && _productSKULvPricesLength) {
    productLvPricesData.forEach((val, index) => {
      delete val.fLevelPrice
      delete val.id
      delete val.pubts
      let _insert = productSKULvPricesData[index] ? val.levelId !== productSKULvPricesData[index].levelId : true
      if (_insert) {
        let _rowdata = productSKULvPricesData.filter(v => v.levelId == val.levelId);
        if (_rowdata.length) {
          val.fLevelPrice = _rowdata[0].fLevelPrice
        }
        productSKULvPricesModel.insertRow(index, val);
      } else {
        productSKULvPricesModel.updateRow(index, val);
      }
    })
    productSKULvPricesData = productSKULvPricesModel.getData();
    let _hash = {};
    let _delIndexs = productSKULvPricesData.map((v, index) => {
      if ((!productLvPricesData[index] || v.levelId !== productLvPricesData[index].levelId) && v._status != "Delete") {
        return index
      }
    })
    _delIndexs = _delIndexs.filter(v => typeof v === 'number')
    if (_delIndexs.length) {
      productSKULvPricesModel.deleteRows(_delIndexs);
    }
  }
  viewmodel.communication({
    type: 'modal',
    payload: { mode: 'inner', groupCode: 'SKU会员价Div', viewModel: viewmodel },
  });
}
const diffmergeCell = (args, viewmodel) => {
  let productskusModel = viewmodel.get('productskus');
  setTimeout(function () {
    let _arr = typeof args === "array" ? args : productskusModel.getAllData();
    if (!_arr.length) return
    // mergecell 判断
    let free_columnsName = [
      'free1',
      'free2',
      'free3',
      'free4',
      'free5',
      'free6',
      'free7',
      'free8',
      'free9',
      'free10',
      'freex1',
      'freex2',
      'freex3',
      'freex4',
      'freex5',
    ];
    let _mostColumnsNameLength;
    let _new_free_columnsName = free_columnsName.filter(v => Object.keys(_arr[0]).includes(v)); // ["freex1", "freex2"]
    let _current_arr = [];
    let _all_arr = [];
    _arr.forEach((val, index) => {
      _new_free_columnsName.forEach((v, i) => {
        if (!_all_arr.includes(val[v])) {
          _all_arr.push(val[v]);
          if (!_current_arr[i]) {
            _current_arr[i] = 1
          } else {
            _current_arr[i]++
          }
        }
      })
    })
    if (_current_arr.length > 1) {
      _current_arr.shift();
      _current_arr = _current_arr.filter(v => v > 5);
      productskusModel.setState('mergeCells', !_current_arr.length); // 设置productskus 合并单元格
    } else {
      productskusModel.setState('mergeCells', true); // 设置productskus 合并单元格
    }
  }, 100);
}
// sku上下架
const diffproductSKUDetail = (viewmodel, statusName) => {
  let productskusModel = viewmodel.get('productskus');
  let productskusData = productskusModel.getAllData();
  let _status = false; //
  productskusData.forEach((v) => {
    _status = _status || v["productSKUDetail!" + statusName];
  })
  const statusObj = {
    status: 'iStatus',
    ustatus: 'iUOrderStatus',
  }
  if (!_status) {
    viewmodel.get('detail!' + statusObj[statusName]).setValue(_status);
  }
}
// 线上库存量
const diffcalTotalInventory = (viewmodel) => {
  let _totalInventory = 0;
  let productskusModel = viewmodel.get('productskus');
  let lInventoryCountModel = viewmodel.get('detail!lInventoryCount');
  let _productskus = productskusModel.getAllData();
  lInventoryCountModel.setDisabled(!!_productskus.length)
  // _productskus = _productskus.filter(v => v['productSKUDetail!status']); // 过滤 只有商城上架 才能被计算线上库存量
  // _productskus.length && _productskus.forEach(val => {
  //   _totalInventory = _totalInventory + Number(val['productSKUDetail!inventoryCount']) || 0;
  // });
  // lInventoryCountModel.setValue(_totalInventory);
};
// 检测来源
const diffSource = (viewmodel, source) => {
  switch (source) {
    case "Orgs":
    case "cargoFile":
      viewmodel.get('btnEdit').setVisible(false);
      viewmodel.get('btnDelete').setVisible(false);
      break;
    case "Customer":
    case "business":
      viewmodel.get('btnEdit').setVisible(false);
      viewmodel.get('btnDelete').setVisible(false);
      viewmodel.execute('updateViewMeta', { code: '适用范围页签', visible: false });
      break;
    default:
  }
}
// 适用范围
const applicationScope = (viewmodel, args) => {
  let productOrgsModel = viewmodel.get(args);
  let productOrgsData = productOrgsModel.getData();
  productOrgsData.forEach((v, index) => {
    if (v.isCreator) {
      productOrgsModel.setCellState(index, "orgName", "disabled", true);
    }
  })
}
// 适用范围 不能分配给同一个组织
const diffOrgsScope = (viewmodel, scope, id) => {
  let data = viewmodel.get(scope).getAllData();
  let _is = true;
  data.forEach((value) => {
    _is = _is && value.orgId !== id
  })
  if (!_is) {
    cb.utils.alert("商品档案不可重复分配给同一个组织，组织分配要唯一", 'warning');
    return false
  } else {
    return true
  }
}
// 适用范围 不能分配给同一个商家
const diffShopScope = (viewmodel, scope, args) => {
  let data = viewmodel.get(scope).getAllData();
  data = data.filter(v => (v.shopId === args.value.id));
  if (data.length) {
    cb.utils.alert("商品档案不可重复分配给同一个商家，商家分配要唯一", 'warning');
    return false
  } else {
    return true
  }
}
const geturl = (_params) => {
  let url;
  let mall_url = localStorage.getItem('mall_url');
  let wid = localStorage.getItem('wid');
  // let org_id = _params.ids ? _params.ids.orgId : null;
  // let shop_id = _params.ids ? _params.ids.shopId : null;
  // let customer_id = _params.ids ? _params.ids.customerId : null;
  let goods_id = _params.id;
  let shopId = _params.shopId
  // let params = null;
  // if (org_id) {
  //   // params=params?params+'&org_id='+org_id:'&org_id='+org_id
  // } else if (shop_id) {
  //   params = params ? params + '&shop_id=' + shop_id : '&shop_id=' + shop_id
  // } else if (customer_id) {
  //   params = params ? params + '&customer_id=' + customer_id : '&customer_id=' + customer_id
  // }
  url = mall_url + '/detail?goods_id=' + goods_id + '&wid=' + wid
  if (shopId) {
    url += '&iShopId=' + shopId
  }
  url += "#!/detail?goods_id=" + goods_id;
  return url
}
const insertState = (obj) => {
  obj && Object.keys(obj).forEach((value) => {
    if (Array.isArray(obj[value])) {
      obj[value] = obj[value].map((val, index) => {
        val = val && insertState(val)
        if (val && val.id && val._status !== 'Delete') {
          val._status = 'Update'
        }
        if (value === 'productskus') {
          val['productSKUDetail!_status'] = !val['productSKUDetail!id'] ? 'Insert' : 'Update';
          val['skudefine!_status'] = !val['skudefine!id'] ? 'Insert' : 'Update';
        }
        return val
      })
    }
  })
  return obj
}
const diffproductskusCode = (viewmodel) => {
  const productskusData = viewmodel.get('productskus').getAllData();
  if (!productskusData.length) return true
  let olddata = [];
  productskusData.forEach((v) => {
    let _code = v.code && v.code.trim();
    if (_code === '0' || !!_code) {
      olddata.push(_code)
    }
  })
  const olddatalength = olddata.length;
  if (!olddatalength) return true
  let newdata = Array.from(new Set(olddata));
  const newdatalength = newdata.length;
  return olddatalength === newdatalength
}
// 按规格核算
const diffisCheckFree = (viewmodel, checkFreesData) => {
  let isCheckFree = _getValue(viewmodel, 'detail!isCheckFree');
  let productCheckFrees = _getValue(viewmodel, 'productCheckFrees');
  let productCheckFreesModel = viewmodel.get('productCheckFrees')
  switch (isCheckFree + '') {
    case '0':
      productCheckFreesModel.setState('dataSource', checkFreesData)
      productCheckFreesModel.setState('disabled', true)
      productCheckFreesModel.deleteItems(createNumberList(checkFreesData.length))
      break
    case '1':
      productCheckFreesModel.setState('disabled', false)
      checkFreesData = checkFreesData.filter(v => !v.disabled)
      productCheckFreesModel.setState('dataSource', checkFreesData)
      break;
    default:
      productCheckFreesModel.setState('dataSource', checkFreesData)
      productCheckFreesModel.deleteItems(createNumberList(checkFreesData.length))
      productCheckFreesModel.setState('disabled', true)
      productCheckFreesModel.setValue(checkFreesData)
  }
}
module.exports = {
  setMinArr, // 设置最低值为0的字段
  staticSKU,
  diffcreator, // 是否是创建者
  diffrealProductAttribute, // 商品性质
  diffvirtualProductAttribute, // 虚拟商品属性
  diffbusinessAttribute, // 业务属性
  diffrealProductAttributeType, // 实物商品属性
  diffSKUCondition, // 判断SKU页签显示的条件之一
  diffsaleChannel, // 销售渠道
  diffbusinesSattriBute, // 业务属性
  diffsaleStyle, // 销售方式
  diffstopstatus, // 启用状态 启用：业务信息 - 上下架 可以选择; 停用 ：业务信息 - 上下架 禁用
  diffiStatus, // 商城上架
  diffiUOrderStatus, // U订货上架
  diffbasicInfo, // 基本信息判断（是否是创建者）
  measurementUnitArr, // 计量单位
  clearTemplate, // 清空模板带来的数据
  diffproductTemplate, // 商品模板
  diffmeasurementUnitArr, // 比较计量单位
  clearmeasurementUnitArr, // 清空计量单位
  updatemeasurementUnitArr, // 更新计量单位
  // clearbatchPriceUnit: clearbatchPriceUnit, // 清空批发报价单位
  // diffbatchPriceUnit: diffbatchPriceUnit, // 批发报价单位
  diffUnit, // 比较 计算单位
  getbaseInfoToSKU, // 获取商品基本信息转换成SKU列表里面的基本信息
  getPriceToSKU, // 获取商品价格转换成SKU列表里面的价格
  diffisDisplayPrice, // 价格提示信息 显示隐藏
  diffisBatchManage, // 批次管理
  diffisExpiryDateManage, // 有效期管理
  diffisSerialNoManage, // 序列号管理 ->加工
  diffdepositDealPayType, // 定金设置方式
  difftimes_ControlTimeType, // 线上付尾款控制方式
  diffenableDeposit, // 启动预订业务
  difftimes_iControlTime, // 线上付尾款规则
  diffdepositPayType, // 支付尾款方式
  diffisProcess, // 加工
  diffprocessType, // 加工方式
  diffcanOrder, // 可预约
  // diffcheckByBatch: diffcheckByBatch, // 按批次核算
  diffSKUShelve, // sku 商城/U订货批量上下架
  diffFreex, //
  diffSKUPropertySums, // 隐藏SKU扩展属性
  diffisCheckFree, // 按规格核算
  diffPropertySums, // 隐藏商品扩展属性
  diffOrderPropertySums, // 商品订单属性
  diffskulvprice, // 会员价
  diffmergeCell,
  diffproductSKUDetail, // SKU列表商城上架
  diffcalTotalInventory, // 线上库存量是否可以编辑
  diffSource, // 检测来源
  applicationScope, // 适用范围
  diffOrgsScope, // 不能分配给同一个组织
  diffShopScope, // 不能分配给同一个商家
  rolesUnits, // 较量计量单位
  hasUnits, // 模板中计量单位 是否有值
  geturl,
  insertState, // 添加status
  diffproductskusCode, // productskus sku编码 重复验证
}



// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_product_VM_pro.js